/**
 * epgTimelineHoursContainer.tsx
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const EpgTimelineHoursContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  // padding-left: ${16 * Screen.widthRatio}px;
  // padding-right: ${12 * Screen.widthRatio}px;
  position: relative;
  width: ${1720 * Screen.widthRatio}px;
`;

export default EpgTimelineHoursContainer;
